import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Container, Card, Button } from "react-bootstrap";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const RoadTestList = () => {
  const [records, setRecords] = useState([]);
  const navigate = useNavigate();
  const { id: paramId } = useParams();

  const role = localStorage.getItem("userRole");
  const isAdmin = role === "1";
  const loggedInId = localStorage.getItem("userId");
  const userId = isAdmin && paramId ? paramId : loggedInId;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const headers = {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        };
        const res = await axios.get(`${API_BASE}/api/roadtest/${userId}`, {
          headers,
        });
        setRecords(res.data || []);
      } catch (err) {
        console.error("❌ Error fetching road tests", err);
      }
    };
    fetchData();
  }, [userId]);

  const formatDateTime = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    if (isNaN(date)) return "";
    return date.toLocaleString("en-US");
  };

  return (
    <Container className="form-wrapper my-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3 className="mb-0">Road Test Driving Evaluation</h3>
        <div>
          <Button
            variant="secondary"
            className="me-2"
            onClick={() =>
              navigate(
                isAdmin && paramId ? `/userhome/${paramId}` : "/userhome",
              )
            }
          >
            Return
          </Button>
          <Button
            variant="success"
            onClick={() => navigate(`/roadtest/${userId}/new`)}
          >
            Add
          </Button>
        </div>
      </div>

      <Card>
        <Card.Body>
          {records.length === 0 ? (
            <div className="text-muted text-center">No road tests found.</div>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "8%" }}>#</th>
                    <th style={{ width: "20%" }}>Date Created</th>
                    <th style={{ width: "110px" }} className="text-center">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {records.map((r, index) => (
                    <tr key={r.rt_id}>
                      <td>{index + 1}</td>
                      <td>{formatDateTime(r.rt_created_date)}</td>

                      <td className="text-center">
                        <Button
                          size="sm"
                          variant="outline-primary"
                          onClick={() =>
                            navigate(`/roadtest/${userId}/detail/${r.rt_id}`)
                          }
                        >
                          Edit
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default RoadTestList;

